enum SidePanelTypeEnum {
  AddSpecialty = "Add Specialty",
  CacheProviderSets = "Cache Provider Sets",
  EditSpecialtyName = "Edit Specialty Name",
  ManageSpecialties = "Manage Specialties",
  ManageProductTypes = "Manage Product Types",
  ReorderProducts = "Reorder Products",
}

export { SidePanelTypeEnum };
